import { BellOff } from 'lucide-react'
import { useNotifications } from '../../../context/notifications'
import { NotificationItem } from './NotificationItem'
import {
  DropdownHeader,
  DropdownSurface,
  DropdownTitle,
  EmptyState,
  EmptySubtitle,
  EmptyTitle,
  HeaderAction,
  ItemList,
} from './styles/NotificationStyles'

interface NotificationDropdownProps {
  onClose: () => void
}

export function NotificationDropdown({ onClose }: NotificationDropdownProps) {
  const { notifications, unreadCount, markRead, markAllRead, remove } = useNotifications()
  const hasItems = notifications.length > 0

  return (
    <DropdownSurface>
      <DropdownHeader>
        <DropdownTitle>Notifications</DropdownTitle>
        <HeaderAction type="link" disabled={unreadCount === 0} onClick={markAllRead}>
          Mark all as read
        </HeaderAction>
      </DropdownHeader>

      {hasItems ? (
        <ItemList>
          {notifications.map((notification) => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              onRead={markRead}
              onDismiss={remove}
              onClose={onClose}
            />
          ))}
        </ItemList>
      ) : (
        <EmptyState>
          <BellOff size={28} aria-hidden />
          <EmptyTitle>You&apos;re all caught up</EmptyTitle>
          <EmptySubtitle>New notifications will show up here.</EmptySubtitle>
        </EmptyState>
      )}
    </DropdownSurface>
  )
}
